import {Page} from "shared/types/VaultTypes";
import {getFeatureFlag} from "./FeatureFlags";
import OpsPage from "../vault/OpsPage";
import {User} from "shared/types/VaultTypes";
const Mixpanel = require("./Mixpanel");

export const trackSimplifiedNavigationVariantImpression = (user: User) => {
	Mixpanel.track("Simplified Navigation Impression", {
		variant: getSimplifyNavigationPhaseVariant(),
		studentID: user.userID,
		studentPlatformUserID: user.platformUserID,
		level: user.model?.gradeID,
	});
};

const getSimplifyNavigationPhaseVariant = () => {
	return getFeatureFlag("ENABLE_SIMPLIFY_NAVIGATION_PHASE", "Control") as
		| "Control"
		| "mini-map-only"
		| "simplify-top-nav"
		| "use-left-nav";
};

export const LEFT_SIDE_NAV_WIDTH = 95;

// Phase 3: Top Nav Simplification
export const shouldSimplifyNavigation = (page: Page) => {
	if (!page || page.demo) return false;
	const variant = getSimplifyNavigationPhaseVariant();
	return (
		variant === "simplify-top-nav" ||
		variant === "mini-map-only" ||
		variant === "use-left-nav"
	);
};

// Phase 4: Avatar Finder
export const shouldRemoveChapterPathScrollbar = () => {
	const variant = getSimplifyNavigationPhaseVariant();
	return variant === "mini-map-only" || variant === "use-left-nav";
};

// Phase 5: Left Nav
export const shouldRenderLeftSideNavBar = (page: Page) => {
	if (!page || page.demo) return false;
	if (OpsPage.isInStudentOnboarding(page)) return false;
	const variant = getSimplifyNavigationPhaseVariant();
	return variant === "use-left-nav";
};

// Phase 7
export const shouldRemoveCampusView = (page: Page) => {
	return false; // Not implemented yet.
};
